import React, { useState, useEffect} from 'react';
import { configData } from "../config";
import { useNavigate, useSearchParams } from 'react-router-dom';
import MinicartLength from './MinicartLength';
import ReactDOM from "react-dom/client";
import Loading from './Loading';
import { captureAttribution } from "./services/AttributionService";																   

function CourseQuickPay() {
    const[searchParams,setSearchParams] = useSearchParams();
    const order_id = localStorage.getItem('order_id');
    const lineitems = searchParams.get("lineitems");
    const quantity  = searchParams.get("quantity");
    //const gclid = searchParams.get("gclid");
    const app_url = configData.APP_URL;
    const navigate = useNavigate();
 const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};

const urlGclid = searchParams.get("gclid");

if (urlGclid) {
  document.cookie =
    "gclid=" + urlGclid +
    ";max-age=" + (90 * 24 * 60 * 60) +
    ";path=/";
}


// when submitting form
const gclid = urlGclid || getCookie("gclid");
    useEffect(()=>{
        Promise.all([
				captureAttribution(),			   
                addtocart(order_id,lineitems,quantity)
            ])
            .then(() => {
         
             navigate("/smww/cart");
            })
        // setTimeout(() => {
        //     const order_id = localStorage.getItem('order_id');
        //     addtocart(order_id,lineitems,quantity);
        //     navigate("/smww/cart");
        //   }, 1600);
       
    },[order_id])

    async function addtocart(order_id,lineitems,quantity) {
        const selectedOption = {[lineitems]: quantity};
        const classroom = {[lineitems]: "0"};
        const postData = {
         lineitems: selectedOption,
         country:'',
        // courses_classroom:classroom,
          order_id: order_id,
          gclid:gclid,
          uid:localStorage.getItem('drupal_uid')
        }
        const response = await fetch(app_url+'smwwcommercepay/addtocart', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
              'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        if(data.data.result === "order_created") {
            localStorage.setItem('order_id', data.data.order_id);
            localStorage.setItem('drupal_orderid', data.data.drupal_orderid);
            const root = ReactDOM.createRoot(document.getElementById("top-header-cart-icon"));
            root.render(<MinicartLength length={data.data.products.length} />);
            navigate("/smww/cart");
        } else {
               
        }
    }
    return (
        <><Loading /></>
      );
}
export default CourseQuickPay;